import axiosInstance from './axiosInstance';
import { cachedGet, invalidate } from './apiCache';
import config from '../config';
import { Branch, CreateBranchDto, UpdateBranchDto } from '../types/branches.types';

const API_URL = `${config.API_BASE_URL}/Branches`;

export const branchesService = {
  getAll: async (): Promise<Branch[]> => {
    return cachedGet('branches_all', async () => {
      const response = await axiosInstance.get<Branch[]>(API_URL);
      return response.data;
    });
  },

  getById: async (id: number): Promise<Branch> => {
    const response = await axiosInstance.get<Branch>(`${API_URL}/${id}`);
    return response.data;
  },

  create: async (branch: CreateBranchDto): Promise<Branch> => {
    const response = await axiosInstance.post<Branch>(API_URL, branch);
    return response.data;
  },

  update: async (id: number, branch: UpdateBranchDto): Promise<Branch> => {
    const response = await axiosInstance.put<Branch>(`${API_URL}/${id}`, branch);
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await axiosInstance.delete(`${API_URL}/${id}`);
  },

  generateCode: async (): Promise<string> => {
    const response = await axiosInstance.get<string>(`${API_URL}/generate-code`);
    return response.data;
  },

  // Get all branches of a specific type (ignores user branch filter)
  getByType: async (branchType: string): Promise<Branch[]> => {
    const response = await axiosInstance.get<Branch[]>(`${API_URL}?includeAllBranches=true&branchType=${branchType}`);
    return response.data;
  },

  // Get the warehouse/bakery branch — it's a Virtual branch that's NOT the Head Office (IsMainBranch=false)
  // (Head Office is also Virtual but with IsMainBranch=true; Bakery has IsMainBranch=false)
  getWarehouseBranch: async (): Promise<Branch | null> => {
    const response = await axiosInstance.get<Branch[]>(`${API_URL}?includeAllBranches=true&branchType=Virtual`);
    return response.data.find(b => !b.isMainBranch) || null;
  },

  // Get only operational branches (BranchType = 'Operational')
  getOperationalBranches: async (): Promise<Branch[]> => {
    const response = await axiosInstance.get<Branch[]>(`${API_URL}?includeAllBranches=true&branchType=Operational`);
    return response.data;
  },
};